import { MapfreButtonComponent } from '../../../_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { CreateNewPasswordExpiredSvgComponent } from '../../../svg/create-new-password-expired-svg/create-new-password-expired-svg.component';
import { MapfreCardComponent } from '../../../_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '../../../_services/acmic.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreCardComponent, CreateNewPasswordExpiredSvgComponent, MapfreButtonComponent],
  selector: 'error-link-expire',
  templateUrl: './error-link-expire.component.html',
  styles: []
})
export class ErrorLinkExpireComponent implements OnInit {

  isAcmic = false;
  constructor(
    private acmicService : AcmicService
  ) { }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
  }

}
